import { render, staticRenderFns } from "./booking_details.vue?vue&type=template&id=464f2a6e&"
import script from "./booking_details.vue?vue&type=script&lang=js&"
export * from "./booking_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports